import { DownloadIcon } from "lucide-react"

import { Button } from "@/components/ui/button"
import { CV_URL } from "@/constants"

export function DownloadButton() {
    const downloadFile = () => {
        const fileName = "Warren Bui CV"
        const aTag = document.createElement("a")
        aTag.href = CV_URL
        aTag.setAttribute("download", fileName)
        document.body.appendChild(aTag)
        aTag.click()
        aTag.remove()
    }
    return (
        <Button size={"lg"}
            onClick={() =>
                downloadFile()
            }
            className="cursor-pointer text-base bg-emerald-600 px-8 py-4 rounded-md font-bold tracking-tight hover:bg-emerald-400 active:scale-[0.98] transition-all flex items-center">
            <span>Download Resume</span>
            <DownloadIcon></DownloadIcon>
        </Button>
    )
}
